import * as tslib_1 from "tslib";
import React from 'react';
import BorderlessSelectContent from './BorderlessSelectContent';
import BorderlessSelectIconLayout from './BorderlessSelectIconLayout';
export default function BorderlessSelectWrapper(props) {
    return (React.createElement(BorderlessSelectContent, tslib_1.__assign({}, props),
        props.children,
        React.createElement(BorderlessSelectIconLayout, { error: props.error, syncIconColor: props.syncIconColor }, props.icon)));
}
//# sourceMappingURL=BorderlessSelectWrapper.js.map